//@ts-nocheck
import { Box, Stack } from "@chakra-ui/react";
import { FormsetWrapper } from "../../components/FormWrapper";
import { useTutorApplicationFlow } from "../../components/VerificationWrapper";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRootStore } from "../../stores";
import { STEPS } from "../../stores/utils";
import GuarantorsInfoForm from "../../tutor-revamp/Guarantors";

type Props = {
  store: IRootStore;
};

function VerificationPage({ store }: Props) {
  const { getFormWrapperProps } = useTutorApplicationFlow(store);
  let guarantorProps = getFormWrapperProps(STEPS.GUARANTOR_INFO);
  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[10, 12]}
      mx="auto"
    >
      <Stack justifyContent="stretch" alignItems="stretch" spacing={[6, 8]}>
        {/* <Box
          p={[0, 10]}
          borderWidth={["none", "2xs"]}
          borderColor="neutral.500"
          boxShadow={["none", "base"]}
          rounded="lg"
        > */}
        <FormsetWrapper
          buttonProps={{
            isLoading: store.loading,
            onClick: () => store.onFormSubmit({}, STEPS.GUARANTOR_INFO, ""),
          }}
          buttonText={guarantorProps.buttonText}
          header={guarantorProps.formHeader}
          description={guarantorProps.description}
          shouldDisplayButton={store.educationWorkHistory.guarantorsCompleted}
          hideStep
        >
          <GuarantorsInfoForm
            label={guarantorProps.label}
            loading={guarantorProps.loading}
            store={guarantorProps.store}
            textData={guarantorProps.textData}
            onSubmit={() => store.onFormSubmit({}, STEPS.GUARANTOR_INFO, "")}
          />
        </FormsetWrapper>
        {/* </Box> */}
      </Stack>
    </Box>
  );
}

export default observer(VerificationPage);
